import React, { useState } from 'react';

// material-ui


// project imports

import 'react-confirm-alert/src/react-confirm-alert.css';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';
import 'survey-core/modern.css';
import 'survey-core/i18n/turkish';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button, Stack, Backdrop, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import html2pdf from 'html2pdf.js';
import ReactToPrint from 'react-to-print';
import CircularProgress from '@mui/material/CircularProgress';
import 'src/assets/css/surveyCustom.css';

const componentStyles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    rootlist: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    }),
    rootlistsag: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    }),

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: {
        zIndex: 2000,
        color: '#fff',
    },
    actionsCCFile: {
        justifyContent: 'flex-end'
    },
    noDisplayInPrint: {
        '@media print': {
            display: 'none'
        }
    },
};

const ServiceDigitalForms = ({ anketSoru, anketCevap, formType }) => {
    const [Loading, setLoading] = useState(false);
    const surveyRef = React.useRef();

    const survey = new Model(anketSoru);
    survey.locale = 'tr';

    survey.mode = "display";
    survey.questionsOnPageMode = "singlePage";



    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }


    function savePdf() {
        setLoading(true);
        setTimeout(() => {
            const input = document.getElementById('survey');
            html2canvas(input).then((canvas) => {
                var imgData = canvas.toDataURL('image/png');
                var imgWidth = 210;
                var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
                var doc = new jsPDF('p', 'mm');
                var position = 0;

                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                doc.save('file.pdf');
                setLoading(false);
            });
        }, 1000);

    }

    function savePdfSpecial() {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const pixelRatio = window.devicePixelRatio;

        setLoading(true);
        var input = surveyRef.current;

        //data-key="question20" olan elementleti bul ve sonuna br tagi ekle
        var q20element = document.querySelector('[data-key="question20"]');
        if (q20element) {
            q20element.innerHTML = q20element.innerHTML + "<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>";
        }

        var q90element = document.querySelector('[data-key="question90"]');
        if (q90element) {
            q90element.innerHTML = q90element.innerHTML + "<br><br><br><br><br><br><br><br><br><br><br>";
        }

        var q100element = document.querySelector('[data-key="question100"]');
        if (q100element) {
            q100element.innerHTML = q100element.innerHTML + "<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>";
        }

        var question16_1 = document.querySelector('[data-key="question16-1"]');
        if (question16_1) {
            question16_1.innerHTML = question16_1.innerHTML + "<br><br><br><br>";
        }

        var question180 = document.querySelector('[data-key="question180"]');
        if (question180) {
            question180.innerHTML = question180.innerHTML + "<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>"
                + "<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>";
        }

        var question21_1 = document.querySelector('[data-key="question21-1"]');
        if (question21_1) {
            question21_1.innerHTML = question21_1.innerHTML + "<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>";
        }

        var question230 = document.querySelector('[data-key="question230"]');
        if (question230) {
            question230.innerHTML = question230.innerHTML + "<br><br><br>";
        }




        setLoading(false);





        setTimeout(() => {
            var input2 = surveyRef.current;
            html2canvas(input2, { windowWidth: 1536, windowHeight: 738, scale: 1.25 }).then((canvas) => {
                var imgData = canvas.toDataURL('image/png');
                var imgWidth = 200;
                var pageHeight = 281;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
                var doc = new jsPDF('p', 'mm');
                var position = 0;

                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                doc.save('file.pdf');
                setLoading(false);
            });
        }, 1000);

    }

    function saveImage() {
        setLoading(true);
        setTimeout(() => {
            //get element "survey" and convert to canvas
            html2canvas(document.getElementById('survey')).then(function (canvas) {
                //save image to local disk
                var link = document.createElement('a');
                link.href = canvas.toDataURL('image/png');
                link.download = 'file.png';
                link.click();
                setLoading(false);
            });
        }, 1000);
    }

    const printPDF = () => {

        setLoading(true);

        setTimeout(() => {
            const element = document.getElementById('survey');

            const opt = {
                margin: [20, 0], // Üst ve alt margin
                filename: 'document.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).save().then(() => {
                setLoading(false);
            });

        }, 1000);
    };



    const windowPrint = () => {
        //sadece surveyRef.current yazdırıyor. window.print() ile
        setLoading(true);
        var printContents = surveyRef.current
        var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        var styles = document.querySelectorAll('style,link[rel="stylesheet"]');
        styles.forEach((style) => {
            pri.document.head.appendChild(style.cloneNode(true));
        });
        // add current styling to pri window
        setTimeout(() => {
            pri.document.open();
            pri.document.write(printContents.innerHTML);
            pri.document.close();
            pri.focus();
            pri.print();
            setLoading(false);
        }, 10000);


    }





    return (
        <div>
            <Backdrop style={componentStyles.backdrop} open={Loading}>
                <CircularProgress color="inherit" />
                <Typography position='absolute'
                    style={{ color: '#FF9800', marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>
                    Dosya oluşturuluyor. Lütfen bekleyiniz...</Typography>
            </Backdrop>
            <Stack direction="row-reverse" spacing={2} sx={componentStyles.noDisplayInPrint}>
                <Button
                    variant="contained"
                    color="secondary"
                    style={{ textTransform: 'none' }}
                    endIcon={<PrintIcon />}
                    onClick={windowPrint}
                >
                    Yazdır CHROME
                </Button>
                <ReactToPrint
                    trigger={() => <Button
                        variant="contained"
                        color="secondary"
                        style={{ textTransform: 'none' }}
                        endIcon={<PrintIcon />}
                    >
                        ReactToPrint
                    </Button>}
                    content={() => surveyRef.current}
                />

                <Button
                    variant="contained"
                    color="secondary"
                    style={{ textTransform: 'none' }}
                    endIcon={<PrintIcon />}
                    onClick={printPDF}
                >
                    Yazdır
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    style={{ textTransform: 'none' }}
                    endIcon={<PrintIcon />}
                    onClick={formType == 99 ? savePdfSpecial : savePdf}
                >
                    PDF Olarak İndir
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    style={{ textTransform: 'none' }}
                    endIcon={<PrintIcon />}
                    onClick={saveImage}
                >
                    Resim Olarak İndir
                </Button>
            </Stack>
            <div ref={surveyRef} >
                <Survey model={survey}
                    data={isJsonString(anketCevap) ? JSON.parse(anketCevap) : anketCevap}
                    emptySurvey="Uygun Form Bulunamadı."
                    id="survey"
                />
            </div>
            <iframe id="ifmcontentstoprint" style={{ height: '0px', width: '0px', position: 'absolute' }}>

            </iframe>
        </div>
    );



};
export default ServiceDigitalForms;